import { environment } from '../../../environments/environment';



enum Mode { VIEW = 1, CREATE = 2, EDIT = 3, NONE = 4, OTHERS = 5, GRAPHS = 6, PRICE_REQUEST = 7, CREDIT_NOTE = 8 };

export class Helper {

  static APPLICATION_SHORT_NAME = 'IVI';
  static ModalMode = Mode;
  static CSS_DISABLE_ACTIONS = 'ifs-action-disabled';
  static CSS_DISABLE_ACTIONS_OVERRIDE = 'ifs-action-disabled-override'; // use if page must override CSS_DISABLE_ACTIONS
  static CSS_ISDELETED_DISABLE_ACTIONS = 'ifs-isdeleted-action-disabled';
  static CSS_DISABLE_THIS_ACTION_ONLY = 'ifs-action-disable-target-icon-only';
  static CSS_HIDE_ICON = "ifs-hide-icon"
  static CSS_DELETE_ACTION_DISABLED = 'ifs-delete-action-disabled';

  static API_URL(): string {
    let apiUrl: string;

    // const data = require('./../../../assets/config/appConfig.json');
    apiUrl = environment.API_URL; // data.API_URL;

    //if (data.env == 'DEV')
    //  apiUrl = data.devAPI_URL; //environment.API_URL;
    //if (data.env == 'PROD')
    //  apiUrl = data.prodAPI_URL; //environment.API_URL;
    //if (data.env == 'TEST')
    //  apiUrl = data.API_URL; //environment.API_URL;

    return apiUrl;
  }
  static BASE_URL(): string {
    let baseUrl: string;

    // const data = require('./../../../assets/config/appConfig.json');

    baseUrl = environment.Base_url;//data.baseUrl;

    return baseUrl;
  }

  static IS_PRODUCTION(): boolean {
    return (environment.production == true);
  }

  static GetUserFilesRelativePath(absolutePath: string): string {

    let scheme = 'https://'
    let schemeIdx = absolutePath.indexOf(scheme);
    let domainOnly = (schemeIdx > -1) ? absolutePath.substring(scheme.length) : absolutePath;

    let formattedFilePath = '';

    // replace backslash with forward slash
    formattedFilePath = domainOnly.replace(/\\/g, "/");

    // replace double forward slash with 1 slash
    formattedFilePath = formattedFilePath.replace(/\/\//g, "/");

    let fullPath = (schemeIdx > -1) ? scheme + formattedFilePath : formattedFilePath;

    return fullPath;
  }

  /**
  * Deep copy function for TypeScript.
  * @param T Generic type of target/copied value.
  * @param target Target value to be copied.
  * @see Source project, ts-deepcopy https://github.com/ykdr2017/ts-deepcopy
  * @see Code pen https://codepen.io/erikvullings/pen/ejyBYg
  */
  public static deepCopy<T>(target: T): T {
    if (target === null) {
      return target;
    }
    if (target instanceof Date) {
      return new Date(target.getTime()) as any;
    }
    if (target instanceof Array) {
      const cp = [] as any[];
      (target as any[]).forEach((v) => { cp.push(v); });
      return cp.map((n: any) => Helper.deepCopy<any>(n)) as any;
    }
    //if (typeof target === 'object' && target !== {}) {
    if (typeof target === 'object') {
      const cp = { ...(target as { [key: string]: any }) } as { [key: string]: any };
      Object.keys(cp).forEach(k => {
        cp[k] = Helper.deepCopy<any>(cp[k]);
      });
      return cp as T;
    }
    return target;
  }

  /**
  * @param {str} The string with html tags
  * @return {str} Returned string with removed html tags
  */
  public static stripHtmlTags(str: any) {
    if ((str === null) || (str === '')) {
      return false;
    } else {
      return str.toString().replace(/<(?:.|\n)*?>/gm, ' ');
    }
  }

  /**
 * @param {int} The month number, 0 based
 * @param {int} The year, not zero based, required to account for leap years
 * @return {Date[]} List with date objects for each day of the month
 */
  public static getDaysInMonth(month: any, year: any) {
    var date = new Date(year, month, 1);
    var days = [];
    while (date.getMonth() === month) {
      days.push(new Date(date));
      date.setDate(date.getDate() + 1);
    }
    return days;
  }

  /**
  * @param {sortParamArray} input array of parameters - criteria for sorting
  * @param {array} The array you want to sort
  * sort array in ascending order
  */
  public static sort(paramArray: any, array: any, order: any = 'asc') {
    if (order == 'asc') {
      let sortedArray = array.sort((j: any, i: any) => paramArray.map((v: any )=> j[v] - i[v]).find((r: any )=> r));
      return sortedArray;
    } else {
      let sortedArray = array.sort((j: any, i: any) => paramArray.map((v: any )=> i[v] - j[v]).find((r: any) => r));
      return sortedArray;
    }

  }

  static Convert = class {

    // convert date to string in 'mm-dd-yyyy' format
    static DateToString(dateParam: Date, delimeter?: string): string {

      let DELIMITER = (!delimeter) ? '-' : delimeter;
      let date = dateParam.getDate();
      let month = dateParam.getMonth() + 1;
      let year = dateParam.getFullYear();

      let formattedVal: any = ((month < 10) ? "0" : "") + month
        + DELIMITER
        + ((date < 10) ? "0" : "") + date
        + DELIMITER
        + ((year < 10) ? "0" : "") + year;

      return formattedVal;
    }

    static DateToString2(dateParam: Date, delimeter?: string): string {

      let DELIMITER = (!delimeter) ? '-' : delimeter;
      let date = dateParam.getDate();
      let month = dateParam.getMonth() + 1;
      let year = dateParam.getFullYear();

      let formattedVal: any = ((year < 10) ? "0" : "") + year
        + DELIMITER
        + ((month < 10) ? "0" : "") + month
        + DELIMITER
        + ((date < 10) ? "0" : "") + date

      return formattedVal;
    }

  }

  // copied from ..\IFS.Common\Helper.cs
  static Constants = class {

    static DailyLogs = class {

      static Actions = class {
        
        static IVI_LIGHT = "User uses IVI Light";
        static PAGE_VIEW = "View Page";
        static STT = "User uses speech to text service.";

        static CREATE = "Create";
        static LOGIN = "Login";
      }

      static Forms = class {

        // Order (IVI)
        static ORDER_OVERVIEW = "Order Overview";
        static IVI_LIGHT = "IVI Light Version";
        static HOME = "IVI Home";
        static INVENTORY_LIST = "Inventory List";

        static USER_MFA = "User MFA";
      }

      static MainTableNames = class {
        // System Tables
        static ALCOHOL_INCLUSION = "tblAlcoholInclude";
        static AUDIT_DEPARTMENTS = "tblAuditDepartment";
        static AUDIT_ITEMS = "tblAuditItems";
        static CLAIMS_CATEGORY = "tblClaimsCategory";
        static CLAIMS_LEVEL = "tblClaimsLevel";
        static COMMUNICATION_RECIPIENTS = "tblCommunicationRecipients";
        static COMMUNICATION_TYPES = "tblCommunicationType";
        static CONTACT_TYPES = "tblContactType";
        static COUNTRY = "tblCountry";
        static CURRENCY = "tblCurrency";
        static DEPARTMENT = "tblDepartment";
        static EXCHANGE_RATES = "tblExchangeRate";
        static HARBORS = "tblHarbor";
        static NATIONALITY = "tblNationality";
        static ORDER_STATUS = "tblOrderStatus";
        static PO_NUMBERS = "tblPONumbers";
        static REASON_FOR_VISIT = "tblShipVisitsReasons";
        static SHIP_PRODUCT_RESTRICTION = "tblShipProductRestriction";
        static SHIP_STATUS = "tblShipStatus";
        static SHIP_TYPES = "tblShipType";
        static SPECIFICATION_TYPE = "tblSpecificationType";
        static UNIT_OF_MEASURE = "tblUOMTable";
        static SURVEY_QUESTIONS = "tblSurveyQuestions";
        static SURVEY_EMAIL_TEMPLATE = "tblSurveyEmailTemplate";
        static SURVEY_EMAIL_QUESTIONS = "tblSurveyEmailQuestions";
        static TEAM_MEMBER_TYPE = "tblTeamMemberType";
        static TEAM = "tblTeam";
        static TEAM_MEMBER = "tblTeamMember";

        // Master Tables
        static COMPANY = "tblCompany";
        static CONTACTS = "tblContacts";
        static OFFICES = "tblOffice";
        static PRODUCT_CATEGORY = "tblCategory";
        static PRODUCT_CATEGORY_GROUP = "tblCategoryGroup";
        static PRODUCTS = "tblProducts";
        static PRODUCT_SUPPLIERS = "tblSuppliersProducts";
        static PRODUCT_SUB_CATEGORY = "tblSubCategory";
        static SHIP = "tblShips";
        static SHIP_MANAGER = "tblShipsManagerOwner";
        static SUPPLIER = "tblSuppliers";
        static SUPPLIER_CONVERSION = "tblSupplierConversionHeader";
        static SHIP_STANDARD_ORDERLISTS = "tblShipStandardOrderLists";
        static QUANTITY_TO_ORDER = "Quantity to Order";

        // Order
        static ORDER_LIST = "tblOrderListHeader";
        static ORDER_INFO = "tblOrderInfoHeader";
        static PRICE_REQUEST = "tblPriceRequestHeader";
        static PRICE_HISTORY = "tblPriceHistory";
        static ORDER_FOLLOWUP = "tblOrderFollowup";
        static SUPPLIER_SURVEY_HEADER = "tblSupplierSurveyHeader";
        static SUPPLIER_SURVEY_DETAIL = "tblSupplierSurveyDetail";

        // Budget 
        static BEGIN_AND_END_STOCK = "tblShipBeginEndStockHeader";
        static BUDGET_INFORMATION_EXPENSE = "tblExpenseInvoice";
        static BUDGET_INFORMATION_INCOME = "tblIncomeInvoice";
        static CLAIMS = "tblClaims";
        static COMMUNICATIONS = "tblCommunication";
        static CONTRACT = "tblContracts";
        static DAILY_MEALS_AND_FESS = "tblDailyMealsAndFees";
        static OUTGOING_INVOICES = "tblIncomeInvoice";
        static SHIP_AUDITS = "tblShipAuditHeader";
        static SHIP_VISITS = "tblShipVisits";
        static SHIP_VISIT_FILES = "tblShipVisitFiles";
        static SHIP_VISITS_PLANNING = "tblShipVisitsPlanning";
        static SUPPLIER_AUDITS = "tblSupplierAuditHeader";
        static SHIP_AUDIT_FILES = "tblShipAuditFiles";

        // Invoices
        static INCOME_INVOICE_HEADER = "tblIncomeInvoiceHeader";

        // Cooks
        static COOK_DOCUMENT_TYPE = "tblCookTypeDocument";
        static FINANCIAL_TRANSACTION_TYPE = "tblTypeFinancialTransaction";
        static ITEM_RECEIVED_TYPE = "tblItemReceivedType";
        static PROMOTION_TYPE = "tblPromotionTypes";
        static SOCIAL_ADVANTAGE = "tblSocialAdvantage";
        static TRAINING_COURSE = "tblTrainingCourses";
        static COOK_PROMOTION = "tblCookPromotion";
        static COOK_FINANCIAL_TRANSACTION = "tblCookFinancialTransaction";
        static COOK_TRAININGS = "tblCookTraining";
        static COOK_FLYING_SQUAD = "tblCookFlyingSquad";
        static COOK_SAILING_HISTORY = "tblCookSailingHistory";
        static COOK_IFS_SAILING_HISTORY = "tblCookIFSSailingHistory";
        static COOK_ITEM_RECEIVED = "tblCookItemReceived";

        static CONTENT_DETAILS = "tblContentDetails";

        // Utilities
        static ROLES = "tblRoles";
        static USERS = "tblUser";

      }

      static Results = class {
        static DENIED = "Denied";
        static FAILED = "Failed";
        static SUCCESSFUL = "Successful";
      }

    }

    static Department = class {
      static FOOD = 1;
      static BONDED = 2;
      static CABIN = 3;
      static UTENSILS = 4;
      static PERSONNEL_SALARY_FEE = 5;
      static CREWING = 6;
    }

    static DocumentType = class {
      static INVOICE = 8;
      static PHOTO = 9;
      static DISCOUNT_CN = 14;
      static CREDIT_NOTE = 18;
      static DAILY_MEALS = 13;
      static AUDIT = 21;
    }

    static BeginAndEndStockTypes = class {
      static BEGIN_STOCK = "Begin Stock";
      static END_STOCK = "End Stock";
    }

    static OrderProcess = class {
      static SUPPLIER_DETAILS_CHECK = "Supplier Details Check";
      static CANCELLEND = "Cancelled";
      static FIRST = "First";
      static FINAL = "Final";
      static ORDER_PLACED = "Order Placed";
      static PRICE_REQUEST_RECEIVED = "PR Received";
      static PRICE_REQUEST_SENT = "PR Sent";
      static CONFIRMED_SUPPLIER = "Confirmed Supplier";
    }

    static SystemContactTypes = class {
      static AGENT = "Agent";
      static AUDITOR = "Auditor";
      static CATERING_INSPECTOR = "Catering Inspector";
      static COOK = "Cook";
      static MASTER = "Master";
      static ORDER_HANDLER = "Order Handler";
      static ORDER_REVIEWER = "Order Reviewer";
      static TEAM_ADMIN = "Team Admin";
    }

    static UserNotificationType = class {
      static INFORMATION = 1;
      static WARNING = 2;
      static FOLLOWUP = 3;
    }

    static Category = class {
      static MEAT = 1;
      static FISH = 2;
      static POULTRY = 3;
    }

    static SubCategory = class {
      static FRESH_FRUIT = 17;
      static FRESH_VEGETABLES = 22;
    }

    static RequestModules = class {
      static SHIP_CREW = "Ship Crew";
      static NOTIFICATION_LIST = "Notification List";
      static NOTIFICATION = "Notification";
      static ORDER_LIST_ITEM = "Order List Item"
      static ORDER = "Order";
      static ORDER_OVERVIEW = "Order Overview";
      static CLAIM = "Claim";
      static DAILY_MEALS = "Daily Meals";
      static DAILY_MEALS_SAVE = "Daily Meals Temp Save";
      static DAILY_MEALS_SUMMARY = "Daily Meals Summary";
      static BEGIN_AND_END_STOCK = "Begin and End Stock";
      static BEGIN_AND_END_STOCK_SAVE = "Begin and End Stock Temp Save";
      static BEGIN_AND_END_STOCK_DELETE = "Begin and End Stock Temp Delete";
      static EXCEPTION = "Exception";
      static ORDER_SURVEY = "Order Survey";
      static ORDER_AGENT_UPDATE = "Order Agent Update";
      static IFS_SURVEY = "IFS Survey";
      static SHIP_AUDIT = "Ship Audit";
    }

    static OrderStatusID = class {
      static FOR_REVIEW = 0;
      static FOR_REVIEW_FROM_IMI = 3;
      static NEW_ORDER = 1;
      static ON_HOLD = 2;
      static PR_SENT = 4;
      static PR_RECEIVED = 5;
      static ORDER_SENT_TO_SHIP = 12;
      static ORDER_RETURNED = 15;
      static ORDER_PLACED = 7;
      static CONFIRMED_BY_SUPPLIER = 17;
      static DELIVERED = 16;
      static SUPPLIER_CONFIRMED = 8;
      static SUPPLIER_CHECK = 9;
      static FINAL = 10;
      static CANCELLED = 11;
    }

    static OrderStatusName = class {
      static FOR_REVIEW = "For Review Captain";
      static FOR_REVIEW_FROM_IMI = "For Review - IMI";
      static SUBMITTED = "Submitted";
    }

    static OrderStatusDesc = class {
      static FOR_REVIEW = "For Review by Captain";
      static FOR_REVIEW_FROM_IMI = "For Review - IMI";
      static SUBMITTED = "Order to be submitted to IFS";
    }

    static DepartmentID = class {
      static FOOD = 1;
      static BONDED = 2;
      static CABIN = 3;
    }

    static MealID = class {
      static BREAKFAST = 1;
      static LUNCH = 2;
      static SUPPER = 3;
      static NIGHT_MEALS = 4;
      static HOLIDAY_BREAKFAST = 5;
      static HOLIDAY_LUNCH = 6;
      static HOLIDAY_SUPPER = 7;
      static HOLIDAY_NIGHT_MEALS = 8;
    }

    static MealCode = class {
      static BREAKFAST = 'BR';
      static LUNCH = 'LU';
      static SUPPER = 'DI';
      static NIGHT_MEALS = 'NM';
    }

    static CrewTypeID = class {
      static NORMAL = 1;
      static SPECIAL = 2;
      static EXTRA = 3;
    }
    static CrewSubTypeID = class {
      static CREW = 1;
      static CAPTAIN = 11;
      static CAMPBOSS = 23;
      static COOK = 12;
    }

    static RoleID = class {
      static COOK = 30;
      static CAPTAIN = 31;
      static CAMPBOSS = 73;
      static SHIP_CLIENT = 41;
    }

    static OfficeID = class {
      static ANTWERP = 1;
      static SINGAPORE = 2;
      static POLAND = 3;
    }

    static Months = [
      { label: 'January', value: 0 },
      { label: 'February', value: 1 },
      { label: 'March', value: 2 },
      { label: 'April', value: 3 },
      { label: 'May', value: 4 },
      { label: 'June', value: 5 },
      { label: 'July', value: 6 },
      { label: 'August', value: 7 },
      { label: 'September', value: 8 },
      { label: 'October', value: 9 },
      { label: 'November', value: 10 },
      { label: 'December', value: 11 }
    ]

    static SurveyQuestionID = class {
      static REMARKS = 4;
    }

    static ContractStatus = class {
      static ACTIVE = 'Active';
      static END = 'End';
    }

    static StockStatusID = class {
      static NEW = 1;
      static TO_BE_REVIEWED = 2;
      static REVIEWED = 3;
      static ACCEPTED = 4;
      static SYSTEM = 5;
    }

    static NutrientID = class {
      static SUGAR = 16;
      static CALORIES = 6;
      static CARBOHYDRATES = 5;
      static SATURATED_FAT = 4;
      static UNSATURATED_FAT = 3;
      static FAT = 2;
      static PROTEIN = 1;
      static NATRIUM = 9;
    }

    static Country = class {
      static THE_NETHERLANDS = 15;
      static BELGIUM = 5;
    }

    static InventoryDisposalType = class {
      static ISSUED_TO_AUTHORITIES = 1;
      static CONDEMNED_ITEMS = 2;
      static STOCK_TRANSFER = 3;
      static STOCK_RECEIVED = 4;
    }

  }

}
